import '@splidejs/splide/dist/css/splide.min.css';

import Splide from '@splidejs/splide';

const ProductAccessories = () => {
  const CONFIG_SPLIDE = {
    arrows: false,
    pagination: false,
    drag: false,
    perPage: 4,
    autoHeight: true,
    breakpoints: {
      1024: {
        perPage: 2,
        pagination: true,
        drag: true
      },
      768: {
        perPage: 2,
        pagination: true,
        drag: true
      }
    }
  };

  const products = document.querySelector(`#ProductAccessories`);

  if (products) {
    if (products.classList.contains('no-js')) {
      products.classList.remove('no-js');
    }

    new Splide(products, CONFIG_SPLIDE).mount();
  }
};

export default ProductAccessories;
